<template>
  <div v-if="currentData" class="case-detail-gene-preview-dailog dialog col-block width-full">
    <div class="title-container row-block">
      <div
        class="title"
        v-html="{
          'ps': $t('DIALOG.caseDetailGenePreview.___psTitle'),
          'pd': $t('DIALOG.caseDetailGenePreview.___pdTitle')
        }[displayType]"
      ></div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="tab-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div
        class="tab-block row-block"
        v-for="(option, oindex) in tabOptions"
        :key="oindex"
        :class="[{ display: display['form'] === option.value }, option.type]"
        @click="e => display['form'] = (display['form'] !== option.value ? option.value : null)"
      >
        <div :style="{ width: '16px' }"></div>
        <div class="tab-title">{{ option.title }}</div>
        <div :style="{ width: '8px' }"></div>
        <img :src="require('../../assets/images/new-tab-display-icon.svg')" alt="">
        <div :style="{ width: '8px' }"></div>
      </div>
    </div>
    <hr class="no-margin">
    <div :style="{ height: '10px' }"></div>
    <template v-if="display['form']">
      <div class="form-container col-block width-full">
        <template v-if="display['form'] === 'display'">
          <genePreviewDisplayForm
            :defaultDatas="currentData['display']"
            :displayType="displayType"
            :variants="variants"
            @dataUpdate="result => editUserSetting('display', result)"
          ></genePreviewDisplayForm>
        </template>
        <template v-else-if="display['form'] === 'select'">
          <template v-if="displayType === 'ps'">
            <span :class="{ alert: (selectedDatas['select'].length >= selectedRange[1]) }" v-html="$t('DIALOG.caseDetailGenePreview.tab.info.select.___ps', { count: selectedDatas['select'].length, limit: selectedRange[1] })"></span>
          </template>
          <genePreviewSelectForm
            :defaultDatas="currentData['select']"
            :displayType="displayType"
            :variants="variants"
            @update="datas => selectedDatas['select'] = datas"
            @dataUpdate="result => editUserSetting('select', result)"
          ></genePreviewSelectForm>
        </template>
      </div>
      <div :style="{ height: '15px' }"></div>
      <hr class="no-margin">
      <div :style="{ height: '15px' }"></div>
    </template>
    <div class="data-container col-block" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block width-full">
        <genePreviewResult
          :defaultDatas="currentData['select']"
          :displayType="displayType"
          :gene="gene"
          :variant="variant"
        ></genePreviewResult>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { putUserSettings } from '../../api'
import genePreviewDisplayForm from '../caseDetail/genePreviewDisplayForm.vue'
import genePreviewSelectForm from '../caseDetail/genePreviewSelectForm.vue'
import genePreviewResult from '../caseDetail/genePreviewResult.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { getReportPreviewColumns, reportPreviewOptions, reportPreviewRangeData } from '../../constants/global/data'

export default {
  components: {
    genePreviewDisplayForm,
    genePreviewSelectForm,
    genePreviewResult
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      currentData: null,
      selectedDatas: {
        'select': []
      },
      display: {
        'form': null
      }
    }
  },
  created () {
    this.setCurrentData(this.userSetting)
  },
  computed: {
    ...mapGetters([
      'userSetting'
    ]),
    selectedRange () {
      return reportPreviewRangeData[this.displayType]
    },
    // static
    dataTransformMap () {
      let map1 = {
        'SpliceAI': [
          'SpliceAI_DS_AL',
          'SpliceAI_DS_DG',
          'SpliceAI_DS_DL',
          'SpliceAI_DP_AG',
          'SpliceAI_DP_AL',
          'SpliceAI_DP_DG',
          'SpliceAI_DP_DL',
          'SpliceAI_DS_AG'
        ]
      }
      let map2 = {}
      return {
        'receive': {
          ...Object.entries(map1).reduce((map, [key, values]) => {
            return {
              ...map,
              ...values.reduce((map, value) => ({ ...map, [value]: [key] }), {})
            }
          }, {}),
          ...map2
        },
        'send': {
          ...Object.entries(map2).reduce((map, [key, values]) => {
            return {
              ...map,
              ...values.reduce((map, value) => ({ ...map, [value]: [key] }), {})
            }
          }, {}),
          ...map1
        }
      }
    },
    tabOptions () {
      return {
        'ps': [
          {
            title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___display'),
            value: 'select',
            type: 'main'
          }
        ],
        'pd': [
          {
            title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___display'),
            value: 'display',
            type: 'main'
          },
          {
            title: this.$t('DIALOG.caseDetailGenePreview.tab.title.___select'),
            value: 'select',
            type: 'sub'
          }
        ]
      }[this.displayType]
    },
    // param
    displayType () {
      return this.param.type
    },
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    }
  },
  watch: {
    'userSetting' (nv) {
      this.setCurrentData(nv)
    }
  },
  methods: {
    ...mapActions([
      'setUserSettingAction'
    ]),
    setCurrentData (userSetting) {
      let selectDatas = Array.prototype.concat.apply([], Object.keys(reportPreviewOptions).map(type => getReportPreviewColumns(userSetting.report_preview_af_columns, 'select', type)))
      selectDatas = Array.prototype.concat.apply([], selectDatas.map(selectData => this.dataTransformMap['receive'][selectData] || [selectData])).filter((x, i, s) => s.indexOf(x) === i)
      let displayDatas = getReportPreviewColumns(userSetting.report_display_af_columns, 'display')
      this.currentData = {
        'select': selectDatas,
        'display': displayDatas
      }
    },
    async editUserSetting (type, result) {
      try {
        let config = this.$ls.get('userInfo')
        let response = null
        if (type === 'display') {
          let data = {
            report_display_af_columns: result
          }
          response = await putUserSettings(data, config)
        } else if (type === 'select') {
          let data = {
            report_preview_af_columns: Array.prototype.concat.apply([], result.map(result => this.dataTransformMap['send'][result] || [result])).filter((x, i, s) => s.indexOf(x) === i)
          }
          response = await putUserSettings(data, config)
        }
        if (response) {
          let userSettings = response.data.data
          this.setUserSettingAction(userSettings)
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGenePreview.vue